import { render } from "./ChurchContributionCreator.vue?vue&type=template&id=6804d913"
import script from "./ChurchContributionCreator.vue?vue&type=script&lang=js"
export * from "./ChurchContributionCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__